import React, { FC, ReactElement } from 'react';
import { localizeType } from '../../commonType';
import withLocalization from '../hoc/withLocalization';
import '../OfferDetails/ADASelector.scss';

interface ADAProps {
  localize: localizeType;
}

const PremiumTextDisplay: FC<ADAProps> = (props: ADAProps): ReactElement => {
  const { localize } = props;

  return (
    <div className="row checkBoxWrapper">
      <div className="col-sm-12">
        <ul className="premiumText">
          <li>{localize('preview-sales-engine.static-content.copy.calendar-page.high-season-symbol')}</li>
        </ul>
      </div>
    </div>
  );
};

export default withLocalization(PremiumTextDisplay);
